import React, { useEffect } from "react";
import PropTypes from "prop-types";
import {
  Container,
  Row,
  Col,
  ListGroup,
  ListGroupItem,
  Card,
  CardBody
} from "reactstrap";
import moment from "moment";

import { connect } from "react-redux";
import { getFormInfo } from "../../actions/forms";

import PanelNavs from "../PanelNavs";
import Loader from "../Loader";
import PageTransition from "../styles/PageTransition";
import ContainerHeader from "../styles/ContainerHeader";
import LoaderWrapper from "../styles/LoaderWrapper";
import ElementWrapper from "../styles/ElementWrapper";

const FormDetail = ({ getFormInfo, match, history, loading, form }) => {
  const fetchData = async () => {
    const response = await getFormInfo(match.params.id);

    if (response !== 200) {
      history.push("/forms");
      return;
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <PageTransition>
      <Container>
        <ContainerHeader>
          <PanelNavs title="Detalle del mensaje" loading={loading} />
        </ContainerHeader>
        {loading ? (
          <LoaderWrapper>
            <Loader noBg={true} />
          </LoaderWrapper>
        ) : (
          <Row className="mb-5">
            <Col sm={6}>
              <ElementWrapper className="p-3 h-100">
                <div className="my-3">
                  <p className="m-0">Nombre: {form.name}</p>
                </div>
                <div className="my-3">
                  <p className="m-0">Email: {form.email}</p>
                </div>
                <div className="my-3">
                  <p className="m-0">Teléfono: {form.phone}</p>
                </div>

                <div className="my-3">
                  <p className="m-0">Título: {form.title}</p>
                </div>

                <div className="my-3">
                  <p className="m-0">
                    Mensaje: <br />
                  </p>
                  <Card>
                    <CardBody>
                      <div dangerouslySetInnerHTML={{ __html: form.message }} />
                    </CardBody>
                  </Card>
                </div>

                <div className="my-3">
                  <p className="m-0">
                    Creado: {moment(form.created_at).format("LLL")}
                  </p>
                </div>

                <div className="my-3">
                  <p className="m-0 mb-2">Tipo de Formularios: </p>
                  <ListGroup>
                    {form.contact_form_type && (
                      <ListGroupItem>
                        <p className="mb-2">
                          Nombre: {form.contact_form_type.name}
                        </p>
                        <p className="mb-2">
                          Descripcion: {form.contact_form_type.description}
                        </p>
                        <span className="mb-2">
                          Emails:
                          <ul>
                            {form.contact_form_type.emails.map(
                              (item, index) => (
                                <li key={index}>
                                  <p>{item.email}</p>
                                </li>
                              )
                            )}
                          </ul>
                        </span>
                      </ListGroupItem>
                    )}
                  </ListGroup>
                </div>
              </ElementWrapper>
            </Col>
          </Row>
        )}
      </Container>
    </PageTransition>
  );
};

FormDetail.propTypes = {
  getFormInfo: PropTypes.func.isRequired,
  form: PropTypes.object.isRequired,
  loading: PropTypes.bool.isRequired
};

const mapStateToProps = state => ({
  form: state.forms.form,
  loading: state.forms.loading
});

export default connect(
  mapStateToProps,
  { getFormInfo }
)(FormDetail);
